/** Key for storing the authentication token */
const AUTH_TOKEN_KEY = "backoffice-auth-token" as const;

/**
 * Manages authentication token storage in localStorage
 * @throws {Error} When token is not found in storage
 */
export const tokenStorage = {
  /**
   * Retrieves the authentication token
   * @returns The stored authentication token
   * @throws {Error} When no token is found
   */
  getToken: (): string => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (!token || token.trim() === "") {
      throw new Error("No authentication token found");
    }
    return token;
  },

  /**
   * Stores the authentication token
   * @param token - The token to store
   */
  setToken: (token: string): void => {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  },

  /**
   * Removes the authentication token from storage
   */
  removeToken: (): void => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
  },
};
